// Strict equality (===): no type coercion between x and y.
export const equals = (x, y) => x === y
